import styled from '@emotion/styled'

import { Color } from '../../enums/color'
import { BadgeSize } from './types/badgeSize'
import { BadgeType } from './types/badgeType'
import { getSizeStyles } from './utils/getSizeStyles'

interface BadgeWrapperProps {
  badgeSize: BadgeSize
  badgeType: BadgeType
  bgColor: Color
  clickable: boolean
  isLarge: boolean
}

export const BadgeWrapper = styled.span<BadgeWrapperProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: ${({ bgColor }) => bgColor};
  white-space: nowrap;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  ${({ badgeType, badgeSize, isLarge }) => getSizeStyles(badgeType, badgeSize, isLarge)}
`
